module.exports = __webpack_public_path__ + "img/6.493bbd04.jpg";